/**
 * ReputationConstant enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ReputationConstant.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ReputationConstant {
  FRIENDLY    = 100,
  NEUTRAL     =  50,
  REP_HOSTILE =   0,
}
